import DrugScreenEvent from './DrugScreenEvent';

export default DrugScreenEvent;
